"use strict";
function includes(items, value) {
    for (var i = 0, ii = items.length; i < ii; i++) {
        if (items[i] === value) {
            return true;
        }
    }
    return false;
}
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = includes;
//# sourceMappingURL=includes.js.map


// WEBPACK FOOTER //
// ./node_modules/arrayq/es6/includes.js